import {
  GET_ALL_GRADING,
  GET_SPEC_DETAIL,
  UNMOUNT_SPEC_TEMPLATE,
  GET_SPEC_LIBRARY_TEMPLATE,
  CLEAR_SPEC_REDUCER,
  GET_ALL_BRAND,
  GET_CATEGORY_ONE_DATA,
  GET_CATEGORY_TWO_DATA,
  GET_CATEGORY_THREE_DATA,
  GET_SPEC_DOCUMENT,
  GET_ALL_SPEC_TEMPLATE,
} from './SpecTemplate.type';

const initialState = {
  SpecDetails: null,
  AllGradingList: [],
  specListData: [],
  totalCount: 0,
  BrandList: [],
  CategoryOneData: [],
  CategoryTwoData: [],
  CategoryThreeData: [],
  specDocumentList: [],
  allSpecList: [],
};
const BomTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_GRADING:
      return {
        ...state,
        AllGradingList: action.payload,
      };

    case GET_SPEC_DETAIL:
      return {
        ...state,
        SpecDetails: action.payload,
      };

    case GET_SPEC_DOCUMENT:
      return {
        ...state,
        specDocumentList: action.payload,
      };

    case UNMOUNT_SPEC_TEMPLATE:
      return {
        ...state,
        SpecDetails: null,
      };
    case GET_SPEC_LIBRARY_TEMPLATE:
      return {
        ...state,
        specListData: action.payload.specArray,
        totalCount: action?.payload?.totalCount,
      };
    case GET_ALL_SPEC_TEMPLATE:
      return {
        ...state,
        allSpecList: action.payload,
      };
    case GET_ALL_BRAND:
      return {
        ...state,
        BrandList: action.payload,
      };
    case GET_CATEGORY_ONE_DATA:
      return {
        ...state,
        CategoryOneData: action.payload,
      };
    case GET_CATEGORY_TWO_DATA:
      return {
        ...state,
        CategoryTwoData: action.payload,
      };
    case GET_CATEGORY_THREE_DATA:
      return {
        ...state,
        CategoryThreeData: action.payload,
      };
    case CLEAR_SPEC_REDUCER:
      console.log('spec reducre');
      return {
        ...state,
        specListData: [],
        totalCount: 0,
      };

    default:
      return state;
  }
};

export default BomTypeReducer;
